export default {
	defaultScale: 1.3,
	blockWidth: {
		compactParams: 110,
		compact: 60,
		normalParams: 220,
		normal: 110
	}
};